import { create } from 'zustand'
import { ISession } from '../type'
import { addAuthorizationHeader } from '../api/base'

type SessionType = ISession;
const RBAC_SESSION_STORE_INIT_VALUE: SessionType = {
  tokens: {
    access: { token: '' },
    refresh: { token: '' },
  },
}
export const useStore = create(() => ({
  ...RBAC_SESSION_STORE_INIT_VALUE
}))

export const setSession: (session:SessionType) => void = (session) => {
  useStore.setState((/*state:QueryOptionType*/) => {
    return ({ ...session })
  })
}

const initalSession = (): ISession => {
  const storageSession:any = localStorage.getItem('rbac-session')
  if (!storageSession) return null
  const tokens = JSON.parse(storageSession)

  addAuthorizationHeader({
    token_type: 'Bearer',
    access_token: tokens.access.token
  })
  setSession({
    tokens: tokens
  })
}
setTimeout(
  () => {
    initalSession()
  },
  200
)
